<re-alert class="mt-2" *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
<div class="modal-custom">
    <div class="modal-header">

        <h4 class="modal-title"><span class="ml-2">Customer Selection</span></h4>


    </div>

    <form role="form" novalidate name="form" #form="ngForm" method="post">

        <fieldset [disabled]="processing">
            <div class="modal-body">


                <div class="row ">
                    <div class="col">
                        <div class="form-group input-required">
                            <label class="mb-2">Customer</label>
                            <span class="spinner spinner-sm text-left ml-2" style="" [hidden]="!processing">
                                <span class="lspinner"></span>
                            </span>
                            <div>Select the customer you want to provide support to</div>

                            <select2 [disabled]="processing" class="mt-2" [(ngModel)]="selectedCustomer" [settings]="{width:'100%'}" [required]="true"
                                     name="selectedLocation"
                                     [options]="customers"></select2>
                        </div>


                    </div>
                </div>





            </div>
        </fieldset>
            <div class="modal-footer mt-4">
                <button type="button" class="btn btn-primary" [disabled]="processing || !form.valid" data-dismiss="modal" (click)="accept()">Select</button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Cancel</button>
            </div>
    </form>

</div>

